
// components/forgotPassword.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { backendUrl } from "./config";
import { Paper, Typography, TextField, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    container: {
        padding: 32,
        maxWidth: 400,
        margin: 'auto',
        backgroundColor: '#fff',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
        borderRadius: 8,
        textAlign: 'center',
    },
    formField: {
        marginBottom: '16px !important',
        width: '100%',
    },
    submitButton: {
        marginTop: 16,
        width: '100%',
        backgroundColor: '#4b9ef1 !important',
        color: '#fff !important',
    },
    backLink: {
        marginTop: 16,
        display: 'block',
    },
}));

const ForgotPassword = () => {
    const classes = useStyles();
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        try {
            // Note the endpoint has been updated to /api/auth/forgot-password
            const response = await fetch(`${backendUrl}/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            if (!response.ok) {
                setMessage(data.message || "An error occurred.");
            } else {
                setMessage(data.message || "If the email exists, a reset link has been sent.");
            }
        } catch (error) {
            setMessage("Error: " + error.message);
        }
    };

    return (
        <Paper className={classes.container}>
            <Typography variant="h5" gutterBottom>
                Forgot Password
            </Typography>
            <form onSubmit={handleForgotPassword}>
                <TextField
                    label="Email Address"
                    variant="outlined"
                    className={classes.formField}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <Button type="submit" variant="contained" className={classes.submitButton}>
                    Send Reset Link
                </Button>
            </form>
            {message && (
                <Typography variant="body2" style={{ marginTop: 16 }}>
                    {message}
                </Typography>
            )}
            <Link to="/signin" className={classes.backLink}>
                Back to Sign In
            </Link>
        </Paper>
    );
};

export default ForgotPassword;
